import { Link, useLocation } from "react-router-dom";
import { AdSlot } from "./AdSlot";
import { SITE_PAGE_LINKS } from "../../components/siteLinks";

/** Shared with the ☰'s legal row — see siteLinks.ts. */
const FOOTER_LINKS = SITE_PAGE_LINKS;

/** Global footer for the control app: the legal pages and the 18+ notice.
 *  Claims no corporate ownership — there is no incorporated entity to claim it.
 *  Hidden on the full-bleed library ("/views"), where the ambient fills the page —
 *  the same exemption this had when the library was `/`, moved with it. */
export function SiteFooter() {
  const { pathname } = useLocation();
  if (pathname === "/views") return null;
  // These pages stay unmonetised. The legal ones because a host, a payment processor or
  // a rights holder reads them when deciding whether to take this site seriously, and an
  // ad banner in the middle of a 2257 statement undoes that; the guide because an ad in
  // the middle of a tutorial is the confusion it exists to reduce.
  // And the shop's checkout and order pages, so a banner never pulls a buyer away mid-purchase.
  const checkout = /^\/shop\/(cart|thanks|orders)(\/|$)/.test(pathname);
  const quiet = checkout || FOOTER_LINKS.some((l) => l.to === pathname);
  // Browse parks a fixed "Filters" pill at `bottom-4` below `md` (see Browse.tsx). The
  // page body already has `pb-28` so the pager clears it, but SiteFooter sits *after*
  // that body — without matching clearance the pill covers the 18+ compliance line.
  const browseFiltersClearance = pathname === "/browse";
  return (
    // `viewport-fit=cover` in index.html runs the page under the home indicator, so the
    // bottom padding has to be the larger of what the design wants and what the device
    // takes. This is the only place on a scrolling page where that shows.
    <footer
      className={
        browseFiltersClearance
          ? "relative z-10 border-t border-[var(--color-edge)] px-6 py-4 pb-[max(7rem,calc(env(safe-area-inset-bottom)+5.5rem))] text-center text-xs text-zinc-500 md:pb-[max(1rem,env(safe-area-inset-bottom))]"
          : "relative z-10 border-t border-[var(--color-edge)] px-6 py-4 pb-[max(1rem,env(safe-area-inset-bottom))] text-center text-xs text-zinc-500"
      }
    >
      {quiet ? null : (
        <AdSlot slot="footer" size={{ width: 300, height: 100 }} className="mb-4" />
      )}
      <p>This platform is built by gooners for gooners.</p>
      {/* Wraps rather than pushing the document sideways on a phone — the same failure the
          header had at 390px. */}
      <nav className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        {FOOTER_LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="text-zinc-400 underline decoration-dotted hover:text-[var(--color-accent)]"
          >
            {l.label}
          </Link>
        ))}
      </nav>
      <p className="mt-2 text-zinc-600">
        All persons depicted were 18 years of age or older at the time of creation.
      </p>
    </footer>
  );
}
